// extracted by mini-css-extract-plugin
export var active = "_c8-2";
export var recordingDot = "_c8-1";
export var recordingIndicator = "_c8-0";